import { getDelayAfterTrigger } from '@esentai/core/features/campaigns/actionResult/selectors';
import { connect } from 'react-redux';

import Delay from './component';

const mapStateToProps = (state, { itemId }) => ({
  delay: getDelayAfterTrigger(state, itemId),
});

export default connect(mapStateToProps)(Delay);
